import React from 'react';
import { Ear, Hammer, Sprout } from 'lucide-react';

const values = [
  {
    Icon: Ear,
    title: 'Listen locally',
    description:
      "Every project begins with genuine engagement\u2014because no one understands Berthoud like the people who live here. We meet with residents, business owners, and town leaders to hear what matters most and uncover the challenges and opportunities that shape how we build.",
    delay: 1 as const,
  },
  {
    Icon: Hammer,
    title: 'Build intentionally',
    description:
      "We design development that solves real problems and supports a cohesive, walkable, connected town. Every project is carefully planned to enhance daily life\u2014making sure each development strengthens the fabric of the community and complements its unique character.",
    delay: 2 as const,
  },
  {
    Icon: Sprout,
    title: 'Grow together',
    description:
      "Our projects strengthen community connection, expand local opportunity, and preserve the character residents love. We work alongside the town throughout every phase, fostering collaboration and trust\u2014because growth is not just about buildings; it is about people.",
    delay: 3 as const,
  },
];

export default function Values() {
  return (
    <section className="values" aria-labelledby="values-heading">
      <div className="section-header">
        <span className="eyebrow reveal">The Garden Spot way</span>
        <h2 id="values-heading" className="reveal">How we work with Berthoud.</h2>
      </div>
      <div className="values-grid">
        {values.map(({ Icon, title, description, delay }) => (
          <article key={title} className={`value-card reveal reveal-delay-${delay}`}>
            <Icon className="value-icon" strokeWidth={1.5} aria-hidden="true" />
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
